import Modal from "react-modal";
import React, { useEffect, useState } from "react";
import Styles from "./complete.module.scss";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { Inputs, props } from "./types";
import { Services } from "Service/service";
import { Error, warningSwal } from "Reusable/utils/Toast";
import Select from "react-select";
import { AiOutlineClose } from "react-icons/ai";
import swal from "sweetalert";
Modal.setAppElement("#root");

const DemoForm: React.FC<props> = ({ modal, setModal, getDetails, id }) => {
    const {
        handleSubmit,
        reset,
        register,
        setValue,
        control,
        watch,
        formState: { errors },
    } = useForm<Inputs>({
        defaultValues: {
            is_partial_completed: false,
            is_revision_class: false,
        },
    });
    // Prevent Enter key from submitting the form (but allow Enter in textarea)
    const handleKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
        if (e.key === "Enter") {
            const target = e.target as HTMLElement | null;
            // allow Enter inside textarea
            if (target && target.tagName !== "TEXTAREA") {
                e.preventDefault();
            }
        }
    };
    const token = {
        Authorization: `token ${localStorage.getItem("learn2readToken")}`,
    };

    const [lessonPlan, setLessonPlan] = useState([]);
    const [partial, setPartial] = useState([]);
    const [isRevision, setIsRevision] = useState(false);

    const [revisionPlans, setRevisionPlans] = useState<any[]>([]);
    const [selectedPlan, setSelectedPlan] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const getLessonPlan = async () => {
        if (isRevision) {
            getRevisionPlans();
        } else {
            setLoading(true);
            try {
                let body = {
                    LessonPlans_Batch: getDetails.data.LessonPlans_Batch,
                    CourseID: getDetails.data.CourseID,
                };
                const getCourseDetails = await Services.get_Lesson_Plan(
                    "POST",
                    JSON.stringify(body),
                    token
                );
                if (getCourseDetails.Status === 1) {
                    setLessonPlan(
                        getCourseDetails.PendingLessonPlans.map(
                            (item: any) => ({
                                label: item.PlanNumber,
                                value: item.PlanNumber,
                            })
                        )
                    );
                    setPartial(
                        getCourseDetails.PendingLessonPlans.map(
                            (item: any) => ({
                                label: item.PlanNumber,
                                value: item.PlanNumber,
                            })
                        )
                    );
                }
            } catch (err: any) {
                console.log(err);
                warningSwal("Error", "Something went wrong please try again");
            } finally {
                setLoading(false);
            }
        }
    };

    const getRevisionPlans = async () => {
        // fetch lesson plans by course id for revision dropdown
        try {
            if (!getDetails?.data?.CourseID) return;
            const res = await Services.LessonPlanByCourseId(
                "GET",
                null,
                token,
                getDetails.data.CourseID
            );
            if (res && res.Status === 1 && Array.isArray(res.LessonPlans)) {
                setLessonPlan(
                    res.LessonPlans.map((item: any) => ({
                        label: item.PlanNumber,
                        value: item.PlanNumber,
                    }))
                );
                setPartial(
                    res.LessonPlans.map((item: any) => ({
                        label: item.PlanNumber,
                        value: item.PlanNumber,
                    }))
                );
            }
        } catch (err) {
            console.log(err);
        }
    };
    const findNonCommonObjects = (arr1: any, arr2: any) => {
        const arr2Set = new Set(arr2.map((obj: any) => JSON.stringify(obj)));
        return arr1.filter((obj: any) => !arr2Set.has(JSON.stringify(obj)));
    };

    useEffect(() => {
        getLessonPlan();
        // getRevisionPlans();
    }, [isRevision]);
    const watchData = watch();
    // CLOSE FORM
    const closeModal = () => {
        setModal(false);
        reset();
    };

    // FORM SUBMIT
    const onSubmit: SubmitHandler<Inputs> = async (formdata) => {
        setLoading(true);
        let Body: any = {
            CourseID: getDetails?.data?.CourseID,
            ScheduleClassID: getDetails?.data?.ScheduleClassID,
            Students: getDetails?.data?.Students,
            FeePerHour: getDetails?.data?.FeePerHour,
            BatchName: getDetails?.data?.BatchName,
            Scheduled_StartTime: getDetails?.data?.Scheduled_StartTime,

            Duration: getDetails?.data?.Duration,
            ClassDuration: getDetails?.data?.ClassDuration,
            BatchSize: getDetails?.data?.BatchSize,
            Scheduled_StartDate:
                getDetails?.data?.Scheduled_StartDate &&
                getDetails?.data?.Scheduled_StartDate != "NA" &&
                String(getDetails?.data?.Scheduled_StartDate).split("T")[0],
            BatchID: getDetails?.data?.BatchID,
            LessonPlans_Batch: getDetails?.data?.LessonPlans_Batch,
            PlanNumber_Batch: getDetails?.data?.PlanNumber_Batch,
            PartiallyCompleted: { IsPartiallyCompleted: 0 },
            Comments: formdata.Comments,
            NewTopicDone: formdata.NewTopicDone,

            TutorEmailID: getDetails?.data?.TutorEmailID,
            LessonPlans_Class: selectedPlan.map((item: any) => item.value),
            IsRevision: watchData.is_revision_class ? 1 : 0,
        };
        if (watchData.is_partial_completed) {
            Body = {
                ...Body,
                IsRevision: watchData.is_revision_class ? 1 : 0,
                PartiallyCompleted: {
                    IsPartiallyCompleted: 1,
                    Slide: formdata.SlideNumber,
                    LessonPlan: formdata.Lesson.value,
                },
            };
        }
        /*  if () {
            const revisionLessonId = Array.isArray(selectedPlan)
                ? selectedPlan.length
                    ? selectedPlan[0].value
                    : null
                : selectedPlan
                ? selectedPlan.value
                : null;
            Body = {
                ...Body,
                isRevisionClass: {
                    IsRevisionClass: 1,
                    LessonPlanID: revisionLessonId || null,
                },
            };
        } */
        try {
            const CompleteClass = await Services.Complete_Class(
                "POST",
                JSON.stringify(Body),
                token
            );
            setLoading(false);
            if (CompleteClass.Status === 1) {
                swal("Completed", CompleteClass.Message, "success");
                setModal(false);
                getDetails?.details(id);
            } else {
                warningSwal("Warning", CompleteClass?.Message);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
            warningSwal("Error", "Something went wrong please try again");
        }
    };
    const customStyles = {
        control: (provided: any, state: any) => ({
            ...provided,
            minHeight: state.hasValue ? "3.3rem" : "3rem", // Adjust the height based on your preference
        }),
    };
    const onPlanSelect = (data: any) => {
        setPartial(findNonCommonObjects(lessonPlan, data));
        setValue("Lesson", []);
        setSelectedPlan(data);
    };

    // when revision is selected we reuse selectedPlan for submission
    return (
        <Modal
            isOpen={modal}
            contentLabel="Modal"
            className={Styles["modal"]}
            onRequestClose={closeModal}
            overlayClassName={Styles["overlay"]}>
            <div className={Styles["form-wrapper"]}>
                <button onClick={closeModal}>
                    <AiOutlineClose />
                </button>
                <h2>Complete Class</h2>
                <form
                    onSubmit={handleSubmit(onSubmit)}
                    onKeyDown={handleKeyDown}>
                    <div className={Styles["form-control"]}>
                        <label htmlFor=""> Completed File Number/s :</label>
                        <div>
                            <Controller
                                name="LessonPlans_Class"
                                control={control}
                                defaultValue={[]}
                                rules={{
                                    required:
                                        watchData.is_partial_completed == 1
                                            ? false
                                            : "This field is required",
                                }}
                                render={({ field }) => (
                                    <>
                                        <Select
                                            {...field}
                                            options={lessonPlan}
                                            styles={customStyles}
                                            isSearchable={false}
                                            onChange={(val) => {
                                                // update react-hook-form value and local state/partials
                                                field.onChange(val);
                                                onPlanSelect(val);
                                            }}
                                            value={field.value}
                                            placeholder="Select plan"
                                            isMulti
                                            isLoading={loading}
                                            closeMenuOnSelect={false}
                                            className={Styles["select"]}
                                            classNames={{
                                                control: (state) =>
                                                    Styles["control"],
                                                indicatorSeparator: () =>
                                                    Styles["indicator"],
                                                valueContainer: () =>
                                                    Styles["valueContainer"],
                                                input: () => Styles["input"],
                                                indicatorsContainer: () =>
                                                    Styles[
                                                        "indicationContainer"
                                                    ],
                                                singleValue: () =>
                                                    Styles["singleValue"],
                                                option: () => Styles["option"],
                                                menu: () => Styles["menu"], // class for the options container
                                                menuList: () =>
                                                    Styles["menuList"],
                                            }}
                                        />
                                        <p></p>
                                        {errors.LessonPlans_Class && (
                                            <p
                                                className={Styles["error-msg"]}
                                                style={{ color: "red" }}>
                                                This is required
                                            </p>
                                        )}
                                    </>
                                )}
                            />
                        </div>
                    </div>
                    {watchData.is_partial_completed && (
                        <div className={Styles["form-control"]}>
                            <label htmlFor="">
                                {" "}
                                Partially Completed File Number/s :
                            </label>
                            <Controller
                                name="Lesson"
                                control={control}
                                defaultValue={""}
                                rules={{
                                    required: "This field is required",
                                }}
                                render={({ field }) => (
                                    <>
                                        <Select
                                            {...field}
                                            options={partial}
                                            styles={customStyles}
                                            isSearchable={false}
                                            placeholder="Select plan"
                                            isLoading={loading}
                                            closeMenuOnSelect={true}
                                            className={Styles["select"]}
                                            classNames={{
                                                control: (state) =>
                                                    Styles["control"],
                                                indicatorSeparator: () =>
                                                    Styles["indicator"],
                                                valueContainer: () =>
                                                    Styles["valueContainer"],
                                                input: () => Styles["input"],
                                                indicatorsContainer: () =>
                                                    Styles[
                                                        "indicationContainer"
                                                    ],
                                                singleValue: () =>
                                                    Styles["singleValue"],
                                                option: () => Styles["option"],
                                                menu: () => Styles["menu"], // class for the options container
                                                menuList: () =>
                                                    Styles["menuList"],
                                            }}
                                        />
                                        <p></p>
                                        {errors.Lesson && (
                                            <p className={Styles["error-msg"]}>
                                                This is required
                                            </p>
                                        )}
                                    </>
                                )}
                            />
                        </div>
                    )}
                    {watchData.is_partial_completed && (
                        <div className={Styles["form-control"]}>
                            <label htmlFor="Comments">
                                Slide Number <span>:</span>
                            </label>
                            <div className={Styles["form-control-one"]}>
                                <input
                                    type="number"
                                    placeholder="Slide number"
                                    {...register("SlideNumber", {
                                        required: true,
                                    })}
                                />
                                {errors.SlideNumber && (
                                    <span className={Styles["error"]}>
                                        Slide Number is required
                                    </span>
                                )}
                            </div>
                        </div>
                    )}
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">
                            Topic taken today <span>:</span>
                        </label>
                        <div className={Styles["form-control-one"]}>
                            <input
                                type="text"
                                {...register("NewTopicDone", {
                                    required: true,
                                })}
                            />
                            {errors.NewTopicDone && (
                                <span style={{ color: "red" }}>
                                    This is required
                                </span>
                            )}
                        </div>
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="Comments">
                            Description of Topic <span>:</span>
                        </label>
                        <div>
                            <textarea
                                {...register("Comments", {
                                    required: true,
                                })}></textarea>
                            {errors.Comments && (
                                <span style={{ color: "red" }}>
                                    This is required
                                </span>
                            )}
                        </div>
                    </div>
                    <div className={Styles["radio-buttons"]}>
                        <label>
                            <Controller
                                name="is_partial_completed"
                                control={control}
                                defaultValue={1}
                                render={({ field }) => (
                                    <>
                                        <input
                                            type="checkbox"
                                            {...field}
                                            value={2}
                                        />
                                        <span
                                            className={Styles["span"]}
                                            style={{ color: "red" }}>
                                            {" "}
                                            Partially Completed
                                        </span>
                                    </>
                                )}
                            />
                        </label>
                    </div>
                    <div className={Styles["radio-buttons"]}>
                        <label>
                            <Controller
                                name="is_revision_class"
                                control={control}
                                defaultValue={false}
                                render={({ field }) => (
                                    <>
                                        <input
                                            type="checkbox"
                                            checked={!!field.value}
                                            onChange={(e) => {
                                                field.onChange(
                                                    e.target.checked
                                                );
                                                setIsRevision(e.target.checked);
                                                setSelectedPlan([]);
                                                setValue(
                                                    "LessonPlans_Class",
                                                    []
                                                );
                                                setValue("Lesson", "");
                                            }}
                                            onBlur={field.onBlur}
                                            name={field.name}
                                            ref={field.ref}
                                        />
                                        <span
                                            className={Styles["span"]}
                                            style={{ color: "red" }}>
                                            {" "}
                                            Revision Done
                                        </span>
                                    </>
                                )}
                            />
                        </label>
                    </div>

                    {/* Revision selection uses the same 'Lesson Completed' dropdown when checked */}
                    {/* eslint-disable-next-line */}

                    <div className={Styles["buttons"]}>
                        <button
                            type="submit"
                            className={Styles["submit"]}
                            disabled={loading}>
                            {loading ? "...please wait" : "Complete"}
                        </button>
                        <button
                            type="button"
                            onClick={closeModal}
                            className={Styles["close"]}>
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};
export default DemoForm;
